// queries/useGetAdminAllModels.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_ADMIN_ALL_MODELS } from "api";
import { FetchModelsParams, UseGetAllModelsParams } from "types";

// Function to fetch models
const fetchModels = async ({ queryKey }: { queryKey: [string, FetchModelsParams] }) => {
  const [, { page, pageSize, email, created_at, start_date, end_date, model_type }] = queryKey;  // Include start_date and end_date
  let queryString = `page=${page}&page_size=${pageSize}`;

  if (email) {
    queryString += `&email=${encodeURIComponent(email)}`;
  }

  if (created_at) {  // Include created_at in the query string
    queryString += `&created_at=${encodeURIComponent(created_at)}`;
  }

  if (start_date) {  // Include start_date in the query string
    queryString += `&start_date=${encodeURIComponent(start_date)}`;
  }

  if (end_date) {  // Include end_date in the query string
    queryString += `&end_date=${encodeURIComponent(end_date)}`;
  }

  if (model_type) { // Include model_type in the query string
    queryString += `&model_type=${encodeURIComponent(model_type)}`;
  }

  return fetch(`${GET_ADMIN_ALL_MODELS}?${queryString}`);
};

// React Query Hook
export const useGetAdminAllModels = (params: UseGetAllModelsParams) => {
  return useQuery({
    queryKey: ["allModels", params],
    queryFn: fetchModels,
    staleTime: 5000, // data is considered fresh for 5 seconds
  });
};

export default useGetAdminAllModels;
